import { ComponentDef } from 'components/knz/types';

/**
 * frontmatter を補ってプレビュー用の完全な knz ソースにする。
 * body が既に frontmatter（先頭 `---`）を持つ場合は二重付与せずそのまま使う
 * （prose: true などを含む読み物サンプルをプレビューできるようにするため）。
 */
export const toPreviewSource = (body: string): string => {
  if (body.trimStart().startsWith('---')) return body;
  return ['---', 'title: プレビュー', 'author:', ' - preview', '---', body].join('\n');
};

/**
 * テンプレート内の指定 param（`key:...` 行）の値を差し替える。
 * 該当行がなければ、開始タグの次行に `key:value` を挿入する。
 * `raw`（text）や複数行値は対象外（単一値 param のバリエーション表示用）。
 */
export const overrideParam = (template: string, key: string, value: string): string => {
  const lines = template.split('\n');
  const keyRe = new RegExp(`^${key}:`);
  const idx = lines.findIndex((l) => keyRe.test(l.trim()));
  if (idx !== -1) {
    lines[idx] = `${key}:${value}`;
    return lines.join('\n');
  }
  // 開始タグ（<--- Name --->）の直後に挿入
  const openIdx = lines.findIndex((l) => /^<---\s*\w+\s*--->$/.test(l.trim()));
  if (openIdx !== -1) {
    lines.splice(openIdx + 1, 0, `${key}:${value}`);
  }
  return lines.join('\n');
};

/**
 * ある param について、サンプル値ごとのバリエーション（value と、その値を適用した
 * プレビュー用ソース）を生成する。サンプル値がなければ空配列。
 */
export const buildParamVariations = (
  def: ComponentDef,
  paramKey: string,
): { value: string; source: string }[] => {
  const param = def.params.find((p) => p.key === paramKey);
  if (!param?.sampleValues || param.sampleValues.length === 0) return [];
  return param.sampleValues.map((value) => ({
    value,
    source: toPreviewSource(overrideParam(def.template, paramKey, value)),
  }));
};

/** アンカー id を生成（コンポーネント名 + param キー） */
export const paramAnchorId = (componentName: string, paramKey: string): string =>
  `${componentName}--${paramKey}`;
